module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Thurnen_COA-132786e6b6260f14a6b760609e2b750a.svg";